<div class="app-toaster ui-g p-0 {{status}}" [@animationOption2]="isVisible ? 'open': 'close'">
  <div class="ui-g-12 p-2 position-relative flex-column flex-center-start">
    <p class="font-12 mb-0 font-bold message-heading">{{message?.heading}}</p>

    <div class="d-flex">
      <div class="font-12" [innerHTML]="message?.body">
      </div>
      <div [class]="message.buttonClass" (click)="handleClick()" *ngIf="message?.buttonText">
        {{message?.buttonText}}</div>
    </div>

    <i class="fal fa-times app-toaster-close"></i>
  </div>
</div>